import Icon from 'veui/components/Icon'
import { IconLinkAlt } from 'dls-icons-vue'

Icon.register('link-alt', IconLinkAlt)
